import { render, staticRenderFns } from "./MessagingTemplateSetup.vue?vue&type=template&id=cd20c0a0&scoped=true"
import script from "./MessagingTemplateSetup.vue?vue&type=script&lang=js"
export * from "./MessagingTemplateSetup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd20c0a0",
  null
  
)

export default component.exports